module.exports = ".cashPrizeImage {\n  height: 6rem;\n  width: 6rem;\n  border-radius: 14%;\n  -o-object-fit: contain;\n     object-fit: contain; }\n"